export function isWindowExists() {
  return typeof window !== 'undefined';
}

export function isDocumentExists() {
  return typeof document !== 'undefined';
}

export function isLifeCycleEventExists() {
  return isWindowExists() && !!window.LIFE_CYCLE_EVENT_BUS;
}

// Runs the callback in the first task after the next frame has been painted (not before it),
// so work started by a click cannot delay the paint that follows that click.
// Returns a function that cancels the pending callback.
export function scheduleAfterNextPaint(callback) {
  if (!isWindowExists()) {
    callback();
    return () => {};
  }
  if (typeof window.requestAnimationFrame !== 'function') {
    const fallbackTimeoutId = setTimeout(callback, 0);
    return () => clearTimeout(fallbackTimeoutId);
  }
  let timeoutId = null;
  const frameId = window.requestAnimationFrame(() => {
    timeoutId = setTimeout(callback, 0);
  });
  return () => {
    window.cancelAnimationFrame(frameId);
    clearTimeout(timeoutId);
  };
}
